import React from "react";
import { useT } from "../i18n/useT";

/** Print-only branded header/footer so PDF output looks intentional. */
export function PrintChrome() {
  const { t, locale } = useT();
  const generated = new Date().toLocaleDateString(locale, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });

  return (
    <>
      <div className="print-only print-banner-top" aria-hidden>
        <strong>{t("layout.brand")}</strong>
        <span>{t("print.tagline", { date: generated })}</span>
      </div>
      <div className="print-only print-banner-bottom" aria-hidden>
        <span>{t("print.footer")}</span>
        <span>budgetos</span>
      </div>
    </>
  );
}
